<!--SelectPopover:  下拉选择 2021/04/18 21:46:01 Sunanguang-->

<template>
   <div class="cm-select-popover">
     <el-popover placement="bottom" trigger="click" popper-class="cm-selection-popover" v-model="showPopover">
        <ul>
          <li v-for="(item, i) in items" :key="'item-' + i" :class="{'active': item.id === selectedItem.id}" :title="item.name"
           @click="selectChange(item)"  data-io-click="tracker">{{item.name}}</li>
        </ul>
        <i slot="reference" class="its-icon its-icon-catalog"></i>
      </el-popover>
   </div>
</template>
<script>
export default {
    name: 'SelectPopover',
    props: {
        items: {
            type: Array,
            default: function () {
                return []
            }
        },
        selectedItem: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    data() {
        return {
            showPopover: false
        }
    },
    methods: {
        selectChange: function (tab) {
            this.showPopover = false
            this.$emit('select-change', tab)
        }
    }
}
</script>

<style scoped>
.cm-class-tabs-more  {
  cursor: pointer;
  color: #757575;
  font-size: 14px;
}

.cm-class-tabs-more:hover {
  color: #0077FF;
}
</style>
<style>
.cm-selection-popover {
  width: 150px;
  padding: 0 !important;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1) !important;

  z-index: 10 !important;
}

.cm-selection-popover ul {
  max-height: 250px;
  overflow-y: auto;
  padding: 10px 0 !important;
}

.cm-selection-popover ul li {
  height: 28px;
  line-height: 28px;
  color: #5D5F64;
  font-size: 14px;
  text-align: center;
  cursor: pointer;
  padding: 0 20px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.cm-selection-popover ul li:hover,
.cm-selection-popover ul li.active {
  background-color: #E0EEFE;
}
</style>